import { isWeb } from '../../utils/platformUtils'
import { BENEFITS_STORE_NAMES } from '../constants'

// Exportar BENEFITS_STORE_NAMES para uso en componentes
export { BENEFITS_STORE_NAMES }

export const addBenefitVoucher = (db, benefit) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS], 'readwrite')
            const objectStore = transaction.objectStore(BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS)

            // Usar put para hacerlo idempotente en web (evita errores por clave existente)
            const request = objectStore.put(benefit)

            request.onsuccess = () => {
                resolve()
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                // Idempotente en SQLite: evita violar UNIQUE(_id)
                const insertStatement = db.prepareSync(`INSERT OR IGNORE INTO ${BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS} (
                    _id, cover_image, description_short, description_long, points, title, terms_and_conditions
                ) VALUES (?, ?, ?, ?, ?, ?, ?)`)

                insertStatement.executeSync([
                    benefit._id,
                    benefit.cover_image,
                    benefit.description_short,
                    benefit.description_long,
                    benefit.points,
                    benefit.title,
                    benefit.terms_and_conditions,
                ])

                insertStatement.finalizeSync()
                resolve()
            } catch (error) {
                console.error('Error in addBenefitVoucher:', error)
                reject(error)
            }
        }
    })
}

export const getBenefitVouchers = (db) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS], 'readonly')
            const objectStore = transaction.objectStore(BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS)
            const request = objectStore.getAll()

            request.onsuccess = (event) => {
                const benefits = event.target.result
                resolve(benefits)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                const statement = db.prepareSync(`SELECT * FROM ${BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS}`)
                let benefits = []
                try {
                    benefits = statement.getAllSync()
                } catch (innerErr) {
                    try {
                        const result = statement.executeSync()
                        benefits = result?.getAllSync?.() || []
                    } catch (e) {
                        console.error('Nested error getting benefit vouchers rows:', e)
                        benefits = []
                    }
                }
                try { statement.finalizeSync() } catch (e) {}
                resolve(benefits)
            } catch (error) {
                console.error('Error in getBenefitVouchers:', error)
                reject(error)
            }
        }
    })
}

export const getBenefitVouchersById = (db, id) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS], 'readonly')
            const objectStore = transaction.objectStore(BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS)
            const request = objectStore.get(id)

            request.onsuccess = (event) => {
                const benefit = event.target.result
                resolve(benefit)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                const statement = db.prepareSync(`SELECT * FROM ${BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS} WHERE _id = ?`)
                const result = statement.executeSync([id])
                const benefit = result.getFirstSync()
                statement.finalizeSync()
                resolve(benefit)
            } catch (error) {
                console.error('Error in getBenefitVouchersById:', error)
                reject(error)
            }
        }
    })
}

// Placeholder functions for other benefits functionality
export const addRedeemVoucher = (db, redeem) => {
    return new Promise((resolve) => {
        console.log('⚠️  addRedeemVoucher temporarily stubbed for SDK 54 migration')
        resolve()
    })
}

export const getRedeemVouchers = (db) => {
    return new Promise((resolve) => {
        console.log('⚠️  getRedeemVouchers temporarily stubbed for SDK 54 migration')
        resolve([])
    })
}

export const addPointsAwarded = (db, points) => {
    return new Promise((resolve) => {
        console.log('⚠️  addPointsAwarded temporarily stubbed for SDK 54 migration')
        resolve()
    })
}

export const getPointsAwarded = (db) => {
    return new Promise((resolve) => {
        console.log('⚠️  getPointsAwarded temporarily stubbed for SDK 54 migration')
        resolve([])
    })
}

// --- Compatibility aliases to satisfy existing imports in UI code ---
// Some components import older names; provide aliases without changing callers
export { getBenefitVouchers as getBenefitsVouchers }
export { getBenefitVouchersById as getBenefitVoucherById }
export const getRedeem = getRedeemVouchers
export const addRedeem = addRedeemVoucher